<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/IN91/IN91.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">IN 9.1 Cockpit Domain Controller</div>
                <div class="detail-banner-desc">
                    IN9.1 is based on the 4th-generation platform SA8295P;<br />
                    It is integrated multi-screen interaction, 3D Vehicle model linkage, car-phone connection, Intelligent driving interaction, Intelligent ecological APP and etc;<br />
                    There is one Type-A port supporting USB audio and video playback, two Type-C interfaces which can be connected to Switch game, mobile phones and VR(Virtual Reality) glasses;<br />
                    It can implement integrated Cluster, IVI(In-Vehicle Infotainment), entertainment displays, APA(Automated Parking Assist) and etc. Besides the basic infotainment function, Face recognition and gesture recognition is also integrated.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>
                    <div class="detail-desc">
                        <div>
                            Qualcomm 4th-generation Snapdragon digital cockpit platform.
                        </div>
                        <div>
                            Multiple operating systems (QNX/Android) on single chip.
                        </div>
                        <div>
                            Up to 11 displays, 10 cameras, 2 analog mic, 6 digital mic, 12 APA/UPA radars.
                        </div>
                        <div>
                            5*100M/1*1000M Ethernet, 4*CAN(FD), 2*LIN.
                        </div>
                        <div>
                            USB 2.0/3.0, WiFi 6E, BT 5.3.
                        </div>
                        <div>
                            HiCar/ICCOA/Carplay/Android Auto.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN91/IN91-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">5nm</div>
                                    <div class="k">Process</div>
                                </div>
                                
                                <div class="spec-item">
                                    <div class="v">3100 GFLOPS</div>
                                    <div class="k">GPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">30/50 TOPS</div>
                                    <div class="k">NPU</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">24G + 256G</div>
                                    <div class="k">Memory</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Up to 11</div>
                                    <div class="k">Display</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">220/256K DMIPS</div>
                                    <div class="k">CPU</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">1000 Base-T1 + 5*100 Base-T1</div>
                                    <div class="k">Ethernet</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Main BT: BT5.2、Vice BT: BT5.2 & BLE、WIFI6 & WIFI6E</div>
                                    <div class="k">BT-WIFI</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                </div>

                <!-- <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN91/IN91-1.jpg" alt="200-1-02">
                    </div>
                    
                </div> -->

                

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: 'IN 9.1 Cockpit Domain Controller - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/IN91.html'

};

import { createApp } from 'vue';
import App from './IN91.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./IN91.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
